export const useIsOnboardingPath = () => {
  const location = window.location // eslint-disable-line no-restricted-properties

  const isOnVirtualMarketerOnboarding = location.pathname.includes('/virtual-marketer-onboarding')
  const isOnRegistration = location.pathname.includes('/signup')
  const isOnLogin = location.pathname.includes('/login')

  return isOnVirtualMarketerOnboarding || isOnRegistration || isOnLogin
}
